import { gql } from 'apollo-boost'

const MARK_BRAND_GATEWAY_TASK_MISC_AS_QC_VERIFIED = gql`
  mutation markBrandGatewayTaskMiscAsQCVerified($id: ID!, $comment: String) {
    markBrandGatewayTaskMiscAsQCVerified(id: $id, comment: $comment) {
      id
      miscTaskQCVerifiedDate
      miscTaskQCVerifiedComment
    }
  }
`

export default MARK_BRAND_GATEWAY_TASK_MISC_AS_QC_VERIFIED
